import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import routes from "../../engine/routes";
import { getTitleByCustomer } from "../../engine/customerConfig";
import { Outlet } from "react-router-dom";

// Helper function to check if a path matches, considering dynamic segments
const matchRoute = (routePath, currentPath) => {
  // Split the route and current path into segments
  const routeSegments = routePath.split("/").filter(Boolean);
  const currentSegments = currentPath.split("/").filter(Boolean);

  // Check if the number of segments (i.e., levels) match
  if (routeSegments.length !== currentSegments.length) {
    return false; // If the levels don't match, return false
  }


  // Check if each segment matches or is a dynamic segment
  return routeSegments.every((segment, i) => {
    return segment.startsWith(":") || segment === currentSegments[i];
  });
};
function DynamicHelmet({ children }) {
  const location = useLocation();

  // Function to find the correct route title
  const findRouteTitle = (currentPath, routesConfig) => {
    for (const key in routesConfig) {
      const route = routesConfig[key];

      if (typeof route === "function") {
        const routeObject = route();
        // console.log(routeObject);

        for (const keyRoute in routeObject) {
          // console.log(keyRoute);
          const itemRoute = routeObject[keyRoute];
          // console.log(itemRoute);

          if (itemRoute.path !== undefined) {
            let isMatch = matchRoute(itemRoute.path, currentPath);

            if (isMatch) {
              return itemRoute.title;
            }
          }

          // NEXT IS SUB SUB ROUTES
          if (typeof itemRoute === "function") {
            let routeDeclaration = itemRoute();
            // console.log(routeDeclaration);
            if (routeDeclaration.path !== undefined) {
              // console.log(routeDeclaration.path);
            }
          }
        }

        // if (
        //   routeObject.path !== undefined &&
        //   matchRoute(routeObject.path, currentPath)
        // ) {
        //   return routeObject.title;
        // }
        //
        // // Check nested routes
        // for (const subRouteKey in routeObject) {
        //   const subRoute = routeObject[subRouteKey];
        //   if (
        //     subRoute &&
        //     typeof subRoute === "object" &&
        //     subRoute.path &&
        //     matchRoute(subRoute.path, currentPath)
        //   ) {
        //     return subRoute.title;
        //   }
        // }
      }
    }

    return "Default Title"; // Fallback title if no match is found
  };
  const pageTitle =
    findRouteTitle(location.pathname, routes) || "Default Title";

  return (
    <>
      <Helmet>
        <title>{`${getTitleByCustomer()} - ${pageTitle}`}</title>
        <meta name="description" content={getTitleByCustomer()} />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={`${pageTitle} - ${getTitleByCustomer()}`}
        />
        <meta property="og:description" content={getTitleByCustomer()} />
      </Helmet>
      <Outlet></Outlet>
    </>
  );
}

export default DynamicHelmet;
